import React, { useState, useEffect } from "react";
import envConstants from "../Constants";
import { Link } from "react-router-dom";
import axios from "../Axiosapi";
import { Helmet } from 'react-helmet-async';

const Brands = () => {
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {


        const fetchBrands = async () => {
            try {
                const response = await axios.get(`${envConstants.API_BASE_URL}/brands`);
                setBrands(response.data.data);
            } catch (error) {
                setError(error);
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchBrands();

    }, []);

    const canonicalUrl = 'https://autopartstation.com.au/brands';
    const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Brands - Auto Part Station",
        "url": "https://autopartstation.com.au/brands",
        "mainEntity": {
            "@type": "Organization",
            "name": "Auto Part Station Pty Ltd",
            "url": "https://autopartstation.com.au",
            "logo": "https://autopartstation.com.au/auto-part.png"
        }
    };

    return (
        <div className="container my-5">
            <Helmet>
                <title>Top Auto Brands - Auto Part Station</title>
                <meta name="description" content={'Explore a wide selection of top auto brands at Auto Part Station. Quality parts for every vehicle!'} />
                <meta name="author" content={envConstants.STORE_META_AUTHOR ? envConstants.STORE_META_AUTHOR : 'Auto Part Station Store'} />
                <meta name="keywords" content={envConstants.STORE_META_KEYWORDS ? envConstants.STORE_META_KEYWORDS : 'online store, purchase online'} />
                <link rel="canonical" href={canonicalUrl} />
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup)}
                </script>
            </Helmet>
            <h1>Brands</h1>
            {loading ? (
                <div className="text-center">Loading...</div>
            ) : (
                <div className="d-flex justify-content-start align-items-center flex-wrap gap-4">
                    {brands.map((brand, index) => (
                        <Link to={`/brand?page=1&brand=` + brand.permalink} key={index}>
                            <img src={brand.logo_image ? envConstants.API_BASE_PUBLIC_URL + brand.logo_image : 'https://via.placeholder.com/150'} alt="Brand 1" style={{ width: '150px', height: '150px', objectFit: 'contain' }} />
                        </Link>
                    ))}
                </div>
            )}
        </div>
    )
}

export default Brands;